<template>
  <StackLayout class="form">
    <slot name="default" />
  </StackLayout>
</template>

<script>

export default {
  name: 'Form',
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    findValidatables (children) {
      let validatables = []

      children = children || this.$children

      children.forEach(child => {
        validatables = validatables.concat(this.findValidatables(child.$children))
        
        if (typeof child.validateByForm === 'function') {
          validatables.push(child)
        }
      })

      return validatables
    },
    validate () {
      let valid = true

      this.findValidatables().forEach(validatable => {
        if (!validatable.validateByForm()) {
          valid = false
        }
      })

      return valid
    }
  }
}

</script>

<style scoped lang="scss">

.form::v-deep .fieldset > * {
  width: 100%;
}

.ns-ios,
.ns-android {
  .form::v-deep .control {
    margin-top: 20;
    
    &.no-margin {
      margin-top: 0;
    }
  }
}

html {
  .form::v-deep .control {
    margin-top: 20px;

    &.no-margin {
      margin-top: 0;
    }
  }

  @media (min-width: 600px) {
    .form::v-deep .fieldset > .control {
      width: 40%;
      flex-grow: 1;
      margin: 20px 10px 0 10px;
    }

    .form::v-deep .fieldset > .control:nth-child(odd) {
      margin-left: 0;
    }

    .form::v-deep .fieldset > .control:last-child:nth-child(odd) {
      margin-left: 0;
      margin-right: 0;
    }

    .form::v-deep .fieldset > .control:nth-child(even) {
      margin-right: 0;
    }
  }
}

</style>